import PropTypes from 'prop-types';
import React from 'react';
import renderType from './renderTypes';

const propTypes = {
	config: PropTypes.object.isRequired,
	name: PropTypes.string,
	object: PropTypes.object,
	row: PropTypes.object,
	getUser: PropTypes.func,
	runStandardIntegrations: PropTypes.func,
	runClick: PropTypes.func,
	utils: PropTypes.object,
	type: PropTypes.string
};

class WidgetRowRender extends React.Component {
	constructor(props) {
		super(props);

		this.runClick = this.runClick.bind(this);
		this.runStandardIntegration = this.runStandardIntegration.bind(this);
	}

	getIcon(icon, extraClasses = '') {
		if (icon.indexOf('http') !== 0) {
			return <i className={`str-icon fa ${icon} ${extraClasses}`} />;
		}

		return <img className={`str-icon ${extraClasses}`} src={icon} />;
	}

	runStandardIntegration(data) {
		this.props.runStandardIntegrations(data);
	}

	runClick(data, optionIndex, runWithData = false) {
		this.props.runClick(data, this.props.config, optionIndex, runWithData);
	}

	render() {
		const { row, config, object, getUser, type, utils } = this.props;
		const RenderType = renderType[row.type];

		const renderTypeProps = {
			row,
			config,
			object,
			getUser,
			type,
			utils,
			runStandardIntegration: this.runStandardIntegration,
			getIcon: this.getIcon,
			runClick: this.runClick
		};

		return <RenderType {...renderTypeProps} />;
	}
}

WidgetRowRender.propTypes = propTypes;
export default WidgetRowRender;
